// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-selection[data-v-3988ab6f]{max-height:300px;overflow-y:auto;border:1px solid #ddd;border-radius:4px;padding:15px}.form-check[data-v-3988ab6f]{padding:8px;border-bottom:1px solid #f0f0f0}.form-check[data-v-3988ab6f]:last-child{border-bottom:none}.form-check-label[data-v-3988ab6f]{margin-left:8px;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
